var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageLayout',[_c('PageHeader',{attrs:{"title":_vm.$t(`Common.title.useRule`),"breadcrumb":[
      {
        title: `${_vm.$t('Common.title.homeTitle')}`,
      },
      {
        title: `${this.$t(
          `Common.title.${this.$route.params?.name?.toString()}`
        )}`,
      },
    ]}}),_c('div',{staticClass:"px-4"},[_c('div',{staticClass:"px-4",staticStyle:{"font-size":"18px"},domProps:{"innerHTML":_vm._s(_vm.$t('Common.title.useRuleStr'))}})]),_c('template',{slot:"actions"},[_c('m-button',{staticClass:"mr-4",attrs:{"type":"primary","ghost":"","size":"large"},on:{"click":_vm.onClose}},[_vm._v(_vm._s(this.$t('Common.action.disagree')))]),_c('m-button',{attrs:{"type":"primary","size":"large"},on:{"click":_vm.onNext}},[_vm._v(_vm._s(this.$t('Common.action.agree')))])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }